import React, { useEffect, useRef, useState } from "react";
import { RadioButton } from "primereact/radiobutton";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { SelectButton } from "primereact/selectbutton";
import InsuranceWraper from "./insurance.style";
import sanad from "../../assets/images/sanad-insurance.svg";
import sanad_plus from "../../assets/images/sanad-plus-insurance.svg";
import alshamel from "../../assets/images/alshamel-insurance.svg";
import { Calendar } from "primereact/calendar";
import { withTranslation } from "react-i18next";
import propTypes from "prop-types";
import * as utils from "../../applications/renewal/helpers/utils";
import * as globalUtils from "../../helpers/utils";
import { classNames } from "primereact/utils";
import { useSelector, useDispatch } from "react-redux";
import { t } from "i18next";
import { changeIsDriverSelected } from "../../redux/actions/renewal";
import motorDriveLogo from "../../assets/images/drive-logo.png";
import TopPick from "../../assets/AnimatedEmojies.gif";

const InsurancePlan = (props) => {
  const productsCodes = globalUtils.getProductsCodes();
  // const [vehicleValueError,setVehicleValueError]=useState("");

  const quotationData = useSelector((state) => state.renewal.quotationDetails);
  const [vehicleValue, setVehicleValue] = useState(
    quotationData.vehicleDetails.vehicleDetailsArray?.[0]?.vehicleValue
  );
  const [deductible, setDeductible] = useState("3500");
  const [deductibleSP, setDeductibleSP] = useState("1250");

  const [repair, setRepair] = useState(
    quotationData.vehicleDetails.vehicleDetailsArray?.[0]?.agencyRepairRequired
  );
  const [showRepair, setShowRepair] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(
    quotationData?.productCode
  );

  const canShowProduct = (productCode) => {
    if (props.isRenewal) {
      const prevProductCode = props.renewalObject.productCode;
      switch (prevProductCode) {
        case productsCodes.SANAD:
          return true;
        case productsCodes.SANAD_PLUS:
          return productCode !== productsCodes.SANAD;
        case productsCodes.AL_SHAMEL:
          return productCode === productsCodes.AL_SHAMEL;
        default:
          return true;
      }
    }
  };

  const getProposal = (productCode) => {
    return props.proposals.find((ele) => ele.productSubCode === productCode);
  };

  const getPriceDetails = (productCode) => {
    const item = getProposal(productCode);

    try {
      if (item) {
        return {
          price: item.premium,
          priceDetailsArray: item?.priceDetails?.priceDetailsArray,
        };
      }
    } catch {
      return { price: item?.premium ?? "", priceDetailsArray: [] };
    }
    
  };

  const plans = [
    {
      icon: sanad,
      productCode: productsCodes.SANAD,
      title: props.i18n.t("POLICY.SANAD"),
      description: props.i18n.t("POLICY.SANAD_DESCRIPTION"),
      show: canShowProduct(productsCodes.SANAD),
      ...getPriceDetails(productsCodes.SANAD),
    },
    {
      icon: sanad_plus,
      productCode: productsCodes.SANAD_PLUS,
      title: props.i18n.t("POLICY.SANAD_PLUS"),
      description: props.i18n.t("POLICY.SANAD_PLUS_DESCRIPTION"),
      show: canShowProduct(productsCodes.SANAD_PLUS),
      ...getPriceDetails(productsCodes.SANAD_PLUS),
    },
    {
      icon: alshamel,
      productCode: productsCodes.AL_SHAMEL,
      title: props.i18n.t("POLICY.ALSHAMEL"),
      description: props.i18n.t("POLICY.ALSHAMEL_DESCRIPTION"),
      show: canShowProduct(productsCodes.AL_SHAMEL),
      ...getPriceDetails(productsCodes.AL_SHAMEL),
    },
  ];

  useEffect(() => {
    if (quotationData?.productCode?.length > 0) {
      const userPlans = plans.filter((item) => +item.price > 0);
      const selectedProductPlan = userPlans[userPlans.length - 1];
      props.onSelectProduct(selectedProductPlan.productCode);
      setSelectedProduct(selectedProductPlan.productCode);
    }
  }, []);

  useEffect(() => {
    const chosenProposal = props.proposals.find(
      (proposal) => proposal.productSubCode === props.chosenProductCode
    );

    if (chosenProposal) {
      setDeductible(chosenProposal?.vehicleArray[0]?.deductible);
      setDeductibleSP(chosenProposal?.vehicleArray[0]?.deductibleSP ?? "1250");
      setRepair(props.quotationData.vehicleDetails.vehicleDetailsArray[0].agencyRepairRequired);
    }
  }, [props.chosenProductCode]);

  useEffect(() => {
    if (
      props.defaultValues &&
      props.defaultValues.vehicleValue &&
      !vehicleValue
    ) {
      props.quotationData.vehicleDetails.vehicleDetailsArray[0].vehicleValue =
        props.defaultValues.vehicleValue.avg;

      if (
        props.quotationData.vehicleDetails.vehicleDetailsArray?.[0]
          ?.vehicleValue.length > 0
      ) {
        // setVehicleValue(props.defaultValues.vehicleValue.avg);
        updateVehicleValue(props.defaultValues.vehicleValue.min);
      }
    }
    if (props.choosenProposal && !deductible) {
      props.quotationData.vehicleDetails.vehicleDetailsArray[0].deductible =
        props.choosenProposal.vehicleArray[0].deductible;
      setDeductible(props.choosenProposal.vehicleArray[0].deductible);
    }
    // props.updateObjectForGetProposalHandler(props.quotationData);
  }, [props]);

  const isArabic = globalUtils.isArabic(props.i18n.language);

  const [inceptionDate, setInceptionDate] = useState(
    utils.getInceptionDate(props.renewalObject.expiryDate)
  );
  const options = [
    { label: t("common.workshop"), value: "N" },
    { label: t("common.agency"), value: "Y" },
  ];
  const inputRef = useRef();
  const getDeductibleItems = () => {
    return [
      {
        label: <span className="lato">{String(500)}</span>,
        value: String(500),
      },
      {
        label: <span className="lato">{String(750)}</span>,
        value: String(750),
      },
      {
        label: <span className="lato">{String(1000)}</span>,
        value: String(1000),
      },
      // { label: <span className="lato">{String(1250)}</span>, value: String(1250) },
      {
        label: <span className="lato">{String(1500)}</span>,
        value: String(1500),
      },
      {
        label: <span className="lato">{String(2000)}</span>,
        value: String(2000),
      },
      {
        label: <span className="lato">{String(2500)}</span>,
        value: String(2500),
      },
      {
        label: <span className="lato">{String(3500)}</span>,
        value: String(3500),
      },
      {
        label: <span className="lato">{String(5000)}</span>,
        value: String(5000),
      },
      {
        label: <span className="lato">{String(10000)}</span>,
        value: String(10000),
      },
    ];
  };

  const updateDeductibleValue = (value) => {
    setDeductible(value);
    props.quotationData.vehicleDetails.vehicleDetailsArray[0].deductible =
      value;
    props.updateObjectForGetProposalHandler(props.quotationData);
  };

  const updateDeductibleSPValue = (value) => {
    setDeductibleSP(value);
    //no need for extra packages
    //structuredClone(value)
    // or
    const clonedQuote = JSON.parse(JSON.stringify(props.quotationData));
    clonedQuote.vehicleDetails.vehicleDetailsArray[0].deductibleSP = value;
    props.updateObjectForGetProposalHandler(clonedQuote);
  };

  const updateVehicleValue = (value) => {
    const defaultValues = props.defaultValues.vehicleValue;
    let vehicleValue = +value;

    if (vehicleValue < +defaultValues.min) {
      // vehicleValue = +defaultValues.min;
      // setVehicleValue(vehicleValue);
      // document.getElementById("custom-card").value = vehicleValue;

      showVehicleValueError("ERROR.vehicleValueLessThanMinValue", {
        min: +defaultValues.min,
      });
      return;
    }
    if (vehicleValue > +defaultValues.max) {
      // vehicleValue = +defaultValues.max;
      // setVehicleValue(vehicleValue);
      // document.getElementById("custom-card").value = vehicleValue;
      showVehicleValueError("ERROR.vehicleValueGreaterThanMaxValue", {
        max: +defaultValues.max,
      });
      return;
    }

    props.setVehicleValueError("");
    setVehicleValue(vehicleValue);
    props.quotationData.vehicleDetails.vehicleDetailsArray[0].vehicleValue =
      vehicleValue.toString();
    props.updateObjectForGetProposalHandler(props.quotationData);
  };

  useEffect(() => {
    if (
      props.chosenProductCode === productsCodes.SANAD ||
      props.chosenProductCode === productsCodes.SANAD_PLUS
    ) {
      setShowRepair(false);

      setRepair("N");
    } else {
      setShowRepair(true);
    }
  }, [props.chosenProductCode, productsCodes]);

  const showVehicleValueError = (message, obj) => {
    props.setVehicleValueError(props.i18n.t(message, obj));
    // setTimeout(()=>{
    //   props.setVehicleValueError("");
    // },1000);
  };

  const changeRepairAgency = (value) => {
    if (value?.length > 0) {
      setRepair(value);
      props.quotationData.vehicleDetails.vehicleDetailsArray[0].agencyRepairRequired =
        value;
    } else {
      setRepair(repair);
      props.quotationData.vehicleDetails.vehicleDetailsArray[0].agencyRepairRequired =
        repair;
    }

    props.updateObjectForGetProposalHandler(props.quotationData);
  };

  const handlePaste = (e) => {
    e.preventDefault();

    // Get the input element by its name
    const input = document.getElementsByName("vehicleValue")[0];

    // Clear the input value after a short timeout
    setTimeout(() => {
      input.value = "";
    }, 0);
  };

  // Motor Drive
  const { driverRegistered } = useSelector((state) => state.renewal);
  const [motorDrive, setMotorDrive] = useState(false);
  const dispatch = useDispatch();

  const handlechange = (e) => {
    setMotorDrive(e.target.checked);
    dispatch(changeIsDriverSelected(e.target.checked));
  };

  const deductibleOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <div>
          {option.deductible} {t("covers_up_to")} {option.coverage}{" "}
        </div>
      </div>
    );
  };

  const getDiscountValues = (proposal) => {
    try {
      let discountAmount =
        +proposal?.priceDetailsArray?.find((elm) => elm.priceCode === "TOTDIS")
          .priceValue ?? 0;

      const totalAmount = +proposal.price + discountAmount;
      const discountPercentage = (
        100 -
        (+proposal.price / totalAmount) * 100
      ).toFixed(0);

      return {
        totalAmount,
        discountPercentage,
        showDiscount: discountAmount > 0 ? true : false,
      };
    } catch {
      return {
        totalAmount: 0,
        discountPercentage: 0,
        showDiscount: false,
      };
    }
  };

  return (
    <InsuranceWraper>
      <div className="container">
        <div className="row">
          <div className="col-md-3 insurance" style={{ textAlign: "initial" }}>
            <h3> {props.i18n.t("POLICY.INSURANCE_PLAN_CHOOSE")}</h3>
          </div>
          <div className="col-md-9 insurance">
            <div className="row insurance-plans">
              <div className="plan-details">
                {plans
                  .filter((item) => item.show)
                  .map((item) => {
                    const discountValues = getDiscountValues(item);
                    return (
                      item.price && (
                        <div
                          style={{
                            opacity: !item.price ? "0.55" : "1",
                            cursor: !item.price ? "not-allowed" : "pointer",
                          }}
                          key={item.productCode}
                          className={
                            "plan-radiobutton" +
                            (item.productCode === props.chosenProductCode
                              ? " box"
                              : "")
                          }
                          onClick={() => {
                            if (item.price) {
                              props.onSelectProduct(item.productCode);
                              setSelectedProduct(item.productCode);
                            }
                          }}
                        >
                          <div className="plan-icon">
                            <img
                              src={item.icon}
                              alt={item.title + " Insurance"}
                            ></img>
                          </div>
                          <div className="plan-title">
                            <h3>{item.title}</h3>
                            {item.productCode === productsCodes.SANAD_PLUS && (
                              <img
                                style={{ width: 35, height: 35 }}
                                src={TopPick}
                                alt=""
                              />
                            )}
                            {item.productCode !== productsCodes.SANAD_PLUS && (
                              <div style={{ marginBottom: 50 }} />
                            )}
                          </div>
                          <div className="plan-desc">
                            <p>{item.description}</p>
                          </div>

                          {discountValues.showDiscount && (
                            <div className="discount_container">
                              <span className={`number text-with-line`}>
                                {discountValues.totalAmount}
                              </span>
                              <div className={`tag_container`}>
                                <span>{`${t("Save")} ${
                                  discountValues.discountPercentage
                                }%`}</span>
                              </div>
                            </div>
                          )}

                          <div>
                            <div className="plan-sr">
                              <h4>
                                <span className="lato">{item.price}</span>{" "}
                                {props.i18n.t("sar")}
                              </h4>
                            </div>
                            <div className="plan-check">
                              <RadioButton
                                disabled={!item.price}
                                inputId="plan1"
                                name="plan"
                                value={item.productCode}
                                checked={
                                  item.productCode === props.chosenProductCode
                                }
                              />
                            </div>
                          </div>
                          <div className="downarrow">
                            <i className="pi pi-angle-down"></i>
                          </div>
                        </div>
                      )
                    );
                  })}
              </div>

              {props.chosenProductCode && (
                <div className="row plan-type mb-3">
                  <div className="col-sm-4 custom-card field">
                    <label className="control-label" htmlFor="custom-card">
                      {props.i18n.t("POLICY.EFFECTIVE_DATE")}
                    </label>
                    <Calendar
                      id="basic"
                      inputClassName="lato"
                      value={inceptionDate}
                      disabled={true}
                      onChange={(e) => setInceptionDate(e.value)}
                      placeholder={inceptionDate}
                    />
                  </div>
                  <div className="col-sm-4 custom-card field">
                    <label className="control-label" htmlFor="custom-card">
                      {props.i18n.t("POLICY.VEHICLE_VALUE")}
                    </label>
                    <InputNumber
                      ref={inputRef}
                      name="vehicleValue"
                      inputId="custom-card"
                      inputClassName="lato"
                      value={parseInt(vehicleValue).toString()}
                      className={classNames({
                        "p-invalid": props.vehicleValueError,
                      })}
                      // min={props.defaultValues.vehicleValue.min}
                      // max={props.defaultValues.vehicleValue.min}
                      onValueChange={(e) =>
                        updateVehicleValue(parseInt(e?.value).toString())
                      }
                      // onBlur={(e) => updateVehicleValue(parseInt(e?.value).toString())}
                      onPaste={handlePaste}
                      mode="decimal"
                      useGrouping={false}
                    />
                    {props.vehicleValueError && (
                      <p className="font-md text-danger">
                        {props.vehicleValueError}
                      </p>
                    )}
                  </div>
                  {selectedProduct === productsCodes.AL_SHAMEL && (
                    <div className="col-sm-4 manufacturing field">
                      <label className="control-label" htmlFor="manufacturing">
                        {props.i18n.t("POLICY.CHANGE_DEDUCTIBLE")}
                      </label>
                      <Dropdown
                        value={deductible}
                        disabled={selectedProduct === productsCodes.SANAD_PLUS}
                        options={getDeductibleItems()}
                        onChange={(e) => updateDeductibleValue(e.value)}
                      />
                    </div>
                  )}

                  {selectedProduct === productsCodes.SANAD_PLUS && (
                    <div className="col-sm-4 manufacturing field">
                      <label className="control-label" htmlFor="manufacturing">
                        {props.i18n.t("POLICY.CHANGE_DEDUCTIBLE")}
                      </label>
                      <Dropdown
                        value={deductibleSP}
                        options={props.defaultValues.spDeductibleList}
                        optionLabel="deductible"
                        optionValue="deductible"
                        onChange={(e) => updateDeductibleSPValue(e.value)}
                        itemTemplate={deductibleOptionTemplate}
                      />
                    </div>
                  )}

                  {showRepair && (
                    <div className="col-sm-4 repair field">
                      <label className="control-label" htmlFor="custom-card">
                        {props.i18n.t("POLICY.CHANGE_REPAIRER_TYPE")}
                      </label>
                      <SelectButton
                        value={repair}
                        options={options}
                        onChange={(e) => changeRepairAgency(e.value)}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="row">
              {props.chosenProductCode &&
                (props.chosenProductCode === "PRMotorImtiazeSP" ||
                  props.chosenProductCode === "PRMotorImtiazeCO") &&
                driverRegistered.isDriverRegistered === false && (
                  <div className="motor-drive">
                    <div className="motor-drive-2">
                      <input
                        type="checkbox"
                        name="motorDriveCheckbox"
                        //value={motorDrive}
                        onChange={handlechange}
                        checked={motorDrive}
                      />
                      <div>
                        <h4 className="motor-drive-title">
                          {t("POLICY.motor-drive-title-1")}
                        </h4>
                        <h4 className="motor-drive-title flex-direction-column">
                          <p>
                            {t("POLICY.motor-drive-title-2")}
                            <span>
                              <bdi>
                                {" "}
                                {props.chosenProductCode ===
                                  "PRMotorImtiazeSP" && "500"}{" "}
                                {props.chosenProductCode ===
                                  "PRMotorImtiazeCO" && "1000"}{" "}
                                {t("POLICY.motor-drive-title-3")}
                              </bdi>
                            </span>
                            {t("POLICY.motor-drive-title-4")} &nbsp;
                            <a
                              href="https://www.tawuniya.com/en/individuals/loyalty-program/drive"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {t("POLICY.motor-drive-title-5")}
                            </a>
                          </p>
                        </h4>
                      </div>
                    </div>
                    <img src={motorDriveLogo} alt="motorDriveLogo" />
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </InsuranceWraper>
  );
};

InsurancePlan.propTypes = propTypes.exact({
  proposals: propTypes.array.isRequired,
  isRenewal: propTypes.bool,
  chosenProductCode: propTypes.string.isRequired,
  renewalObject: propTypes.any.isRequired,
  onSelectProduct: propTypes.func.isRequired,
  defaultValues: propTypes.any.isRequired,
  choosenProposal: propTypes.any,
  updateObjectForGetProposalHandler: propTypes.func.isRequired,
  quotationData: propTypes.func.isRequired,
}).isRequired;
export default withTranslation()(InsurancePlan);
